<template>
  <div class="background" id="aaa">
    <div class="back" @click="back()">🔙</div>
    <div class="works" @click="works()">全部任务</div>
    <div class="done" @click="done()">已完成列表</div>
    <div class="title">{{msg}}</div>
    <div class="longTime">{{longTime}}</div>

<!--    <audio :src="music" loop="true" class="music"-->
<!--           autoplay="autoplay" preload="auto" controls="controls"></audio>-->

    <div class="scol" >
        <iframe v-show="musicOpen"  class="music" v-for="item in musicData" frameborder="no" border="0" marginwidth="0" marginheight="0"
                :src="'//music.163.com/outchain/player?type=2&amp;id=' + item +'&amp;auto=1&amp;height=66'"></iframe>
    </div>
    <div class="scolOpen" @click="openClose()">&nbsp;&nbsp;开/关</div>

    <input type="text" class="thing" v-model="title" />
    <select class="colors" v-model="colors" :style="selectStyle" onChange="this.style.backgroundColor=this.options[this.selectedIndex].style.backgroundColor">
      <option value="green" style="background: #72b362; color: #FFF;">G</option>
      <option value="blue" style="background: #7b9ce1; color: #FFF;" selected>B</option>
      <option value="red" style="background: #bd6d6c; color: #FFF;">R</option>
    </select>
    <div class="begin" @click="start()">{{begin}}</div>
    <div class="over" @click="end()">{{over}}</div>
    <div class="world">{{world}}</div>
  </div>

</template>

<script>
  export default {
    name: 'Time',
    data () {
      return {
        baseUrl: 'http://goc6.com',//''process.env.baseUrl'',//process
        msg: "TIMING",
        longTime: localStorage.getItem('longTime') ? ("生涯："+ localStorage.getItem('longTime')) : "",
        world: "",
        begin: "开始",
        over: "结束",
        interval: null,
        startTime: 0,
        endTime: 0,
        title: "",
        current: "end",
        colors: "blue",
        selectStyle: "background: #7b9ce1; color: #FFF;",
        colorStyleMap: {
          green : "background: #72b362; color: #FFF;",
          blue : "background: #7b9ce1; color: #FFF;",
          red : "background: #bd6d6c; color: #FFF;"
        },
        fullscreen: document.fullscreen,
        music: 'http://4et.oss-cn-beijing.aliyuncs.com/4et/app/background.mp3',
        musicData: [],
        musicOpen: true
      }
    },
    mounted () {
      this.recover();
      this.taskList();
      this.getWorld();
      this.getMusic();
    },
    methods: {
      openClose(){
          this.musicOpen = !this.musicOpen;
      },
      back (){
        window.location.href="/";
      },
      works (){
        window.location.href="/work";
      },
      done (){
        window.location.href="/detail";
      },
      getMusic (){
        const url = this.baseUrl + '/front/config/music';
        let that = this;
        this.$axios.get(url, {
        }).then(function (response) {
          that.musicData = JSON.parse(response.data.content) || [];
        })
      },
      getWorld (){
        const url = "https://api.ixiaowai.cn/ylapi/index.php";
        //"https://www.inqingdao.cn/hitokoto/";
        //http://api.eei8.cn/say/api.php
        let that = this;
        this.$axios.get(url, {
        },{headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }}).then(function (response) {
          that.world = response.data || "";
        })
      },
      start () {
        if(this.title===""){ alert("请输入事件。"); return ; }
        if(this.current === "start"){ alert("已开始，请勿重复点击。"); return ; }

        this.current = "start";
        this.startTime = new Date().getTime();
        this.msg = "00:00:00";
        let that = this;
        this.interval = setInterval(function(){
          that.msg = that.calTime();
        },1000);
        let caches = {
          title: that.title,
          colors: that.colors,
          startTime: that.startTime
        }
        localStorage.setItem("caches", JSON.stringify(caches))
      },
      end () {
        if(this.current === "end"){ alert("已结束，请勿重复点击。"); return ; }
        this.current = "end";
        clearInterval(this.interval);
        this.endTime = new Date().getTime();
        let that = this;
        const url = this.baseUrl + "/front/time/save";
        this.$axios.post(url, {
          start: that.startTime,
          end: that.endTime,
          title: that.title,
          color: that.colors,
          player: localStorage.getItem("player")
        }).then(function (response) {
        })
        localStorage.removeItem("caches");
      },
      taskList (){
        //任务列表跳转
        let titleInfo = localStorage.getItem("title");
        let color = localStorage.getItem("color");
        if(!titleInfo){
          return ;
        }
        if(this.current === "start"){
          this.end();
        }
        this.title = titleInfo;
        this.colors = color;
        this.selectStyle = this.colorStyleMap[color];
        localStorage.removeItem("title");
        localStorage.removeItem("color");
        this.start();
      },
      recover(){
        //意外关闭后可以恢复
        if(!localStorage.getItem("caches")){
          return ;
        }
        this.current = "start";
        let caches = JSON.parse(localStorage.getItem("caches"));
        this.startTime = caches.startTime;
        this.colors = caches.colors;
        if(this.colors!="blue" && new Date().getTime() - this.startTime > 4*3600*1000){ // 非蓝色大于4个小时，不再恢复
            localStorage.removeItem("caches");
            return ;
        }else if(this.colors=="blue" && new Date().getTime() - this.startTime > 12*3600*1000){ // 蓝色大于12个小时，不再恢复
          localStorage.removeItem("caches");
          return ;
        }
        this.title = caches.title;

        this.selectStyle = this.colorStyleMap[this.colors];
        this.msg = "00:00:00";
        let that = this;
        this.interval = setInterval(function(){
          that.msg = that.calTime();
        },1000);
      },
      calTime() {
        let str = "";
        let period = new Date().getTime() - this.startTime;
        if (parseInt(period/1000/3600) > 0) {
          str += this.doubleZero(parseInt(period/1000/3600)) +":";
          period = parseInt(period%(1000 * 3600));
        }else{
          str += "00:";
        }
        if(parseInt(period/1000/60) > 0){
          str += this.doubleZero(parseInt(period/1000/60)) +":";
          period = parseInt(period%(1000 * 60));
        }else{
          str += "00:";
        }
        if(parseInt(period/1000) > 0){
          str += this.doubleZero(parseInt(period/1000)) +"";
          period = parseInt(period%(1000));
        }else{
          str += "00";
        }
        return str;
      },
      doubleZero(num){
        if((num+"").length===1){
          return "0"+num;
        }else{
          return num;
        }
      },
      screen(){
        // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
        let element = document.getElementById('aaa');//设置后就是   id==con_lf_top_div 的容器全屏
        // if (document.fullscreen) {
        //   if (document.exitFullscreen) {
        //     document.exitFullscreen();
        //   } else if (document.webkitCancelFullScreen) {
        //     document.webkitCancelFullScreen();
        //   } else if (document.mozCancelFullScreen) {
        //     document.mozCancelFullScreen();
        //   } else if (document.msExitFullscreen) {
        //     document.msExitFullscreen();
        //   }
        // } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        // }
        // this.fullscreen = !this.fullscreen;

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  .background{
    background-image: url("https://tu.ltyuanfang.cn/api/fengjing.php");
    height: 100%;
    width: 100%;
    position: absolute;
    background-size:cover;
    background-position: center;
    /*background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: 100% 100%;*/
  }

  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/
  .works{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 12%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 0.6rem;
    font-weight: bold;
    text-align: center;
  }
  .back{
    opacity:0.8;
    border-radius:0px 10px;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 12%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 0.6rem;
    font-weight: bold;
    text-align: center;
  }
  .done{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 12%;
    left: 70%;
    color: rgb(61, 50, 39);
    font-size: 0.6rem;
    font-weight: bold;
    text-align: center;
  }
  .title{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 16%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .longTime {
    opacity:0.8;
    border-radius:5px 5px;
    background: #FFF;
    position: absolute;
    width: 46%;
    top: 25%;
    left: 27%;
    color: rgb(61, 50, 39);
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
  }
  .begin {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 30%;
    top: 86%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }
  .over {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 30%;
    top: 86%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  .list {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 86%;
    left: 40%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }


  .world {
    opacity:0.8;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 5%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 0.8rem;
    font-weight: bold;
    text-align: center;
    border-radius:10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }

  .music {
    width: 80px;
    height: 100px;
    text-align: center;
  }
  .scolOpen {
    position: absolute;
    opacity:0.8;
    border-radius:10px 10px;
    background: #FFF;
    width: 15%;
    top: 60%;
    left: 85%;
    margin-top: 40px;
    color: rgb(61, 50, 39);
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
  }
  .scol {
    width: 90%;
    height: 100px;
    position: absolute;
    overflow: scroll;
    top: 60%;
  }

  .thing {
    position: absolute;
    width: 40%;
    height: 50px;
    top: 75%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }
  .colors {
    opacity: 0.8;
    border-radius: 10px;
    background: #FFF;
    position: absolute;
    width: 20%;
    height: 50px;
    top: 75%;
    left: 60%;
    color: rgb(61, 50, 39);
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/Time.vue